import { Controller } from "@hotwired/stimulus"

// Formatka klienta CRM: checkbox „Drugi adres” pokazuje/chowa pole adresu (target moreInfo)
export default class extends Controller {
  static targets = ["moreInfo", "tag"]
  static values = { loaded: Boolean }

  connect() {
    this.loadedValue = true
  }

  showMore() {
    this.moreInfoTarget.classList.toggle("hidden")
    if (!this.moreInfoTarget.classList.contains("hidden")) this.moreInfoTarget.focus()
  }
}
